import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { chatBubbleIcon, bellIconBlue, CloseCircular } from "../../assets/images";
import Button from "../button";
import "./index.scss";
import { GetUserLoginData } from "../../util/reduxData";

const DISMISSED_KEY = "chatNotificationAlertDismissed";

const ChatNotificationAlert = () => {
    const history = useHistory();
    const loginData = GetUserLoginData();

    const [visible, setVisible] = useState(() => {
        if (!("Notification" in window)) return false;

        const wasDismissed = localStorage.getItem(DISMISSED_KEY) === "true";
        const permissionPending = Notification.permission === "default";

        return !wasDismissed && permissionPending;
    });

    const dismiss = () => {
        localStorage.setItem(DISMISSED_KEY, "true");
        setVisible(false);
    };

    const handleAllowNotifications = async () => {
        if ("Notification" in window) {
            await Notification.requestPermission();
        }
        dismiss();
    };

    const handleGoToPreferences = () => {
        const path =
            loginData?.instrId > 0
            ? "/settings/notification-settings/1"
            : "/client-profile/notification-settings/1";
        history.push(path);
        dismiss();
    };

    if (!visible) return null;

    return (
        <div className="chatNotificationAlert">
            <div className="chatNotificationAlertHeader">
                <div className="chatNotificationAlertIconWrap">
                    <img
                        src={chatBubbleIcon}
                        alt="chat"
                        className="chatNotificationAlertChatIcon"
                    />
                    <img
                        src={bellIconBlue}
                        alt="notifications"
                        className="chatNotificationAlertBellIcon"
                    />
                </div>
                <img
                    src={CloseCircular}
                    alt="close"
                    className="chatNotificationAlertClose"
                    onClick={dismiss}
                />
            </div>
            <div className="chatNotificationAlertBody">
                <p className="font18Black boldFont chatNotificationAlertTitle">
                    New Messaging System
                </p>
                <p className="chatNotificationAlertText">
                    There is a new messaging system to TTA Connect and one of your
                    jobs has been enabled with this functionality. By
                    allowing browser notifications, you can stay up to
                    date in your conversations. You can always adjust your
                    preferences in your account settings.
                    
                </p>
            </div>
            <div className="chatNotificationAlertFooter">
                <Button
                    label="Allow Notifications"
                    type="btn"
                    className="btn-blue chatNotificationAlertBtn"
                    onClick={handleAllowNotifications}
                />
                <p
                    className="font14Blue chatNotificationAlertPrefLink"
                    onClick={handleGoToPreferences}
                >
                    Notification Preferences
                </p>
            </div>
        </div>
    );
};

export default ChatNotificationAlert;
